import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService } from '../../linkedservice/azure-data-lake-store-gen2-cosmos-structured-stream.linkedservice';
import { AuthenticationType } from 'app/interfaces/IAuthenticationType';
import { secretBaseToPasswordOrAKV, passwordOrAKVtoSecretBase } from './azure-key-vault.util';
import { ReferenceAdapter } from '../reference.adapter';
import { Credential } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                accountKey: 'secret',
                tenant: '*',
                servicePrincipalId: '*',
                servicePrincipalKey: 'secret',
                encryptedCredential: '*',
                credential: '*'
            }
        }
    }
})
export class AzureDataLakeStoreGen2CosmosStructuredStreamLinkedServiceAdapter extends LinkedServiceAdapter<AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService> {
    protected modelConstructor(): new () => AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService {
        return AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService;
    }

    protected model(): IModel {
        return AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService, linkedServiceResource: Model.LinkedServiceResource):
        Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService;

        properties.type = Metamodel.modelFor(AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService).name;

        properties.typeProperties = {
            url: linkedService.url,
            accountKey: linkedService.authenticationType === AuthenticationType.AccountKey ?
                passwordOrAKVtoSecretBase(linkedService.accountKey, this.context) : undefined,
            tenant: linkedService.authenticationType === AuthenticationType.ServicePrincipal ?
                linkedService.tenant : undefined,
            servicePrincipalId: linkedService.authenticationType === AuthenticationType.ServicePrincipal ?
                linkedService.servicePrincipalId : undefined,
            servicePrincipalKey: linkedService.authenticationType === AuthenticationType.ServicePrincipal ?
                passwordOrAKVtoSecretBase(linkedService.servicePrincipalKey, this.context) : undefined,
            credential: linkedService.authenticationType === AuthenticationType.Credential && linkedService.credential
                ? (ReferenceAdapter.toResource(linkedService.credential, this.context) as Model.CredentialReference)
                : undefined
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService):
        Promise<AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService> {
        const properties = linkedServiceResource.properties as Model.AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService;
        linkedService.url = properties.typeProperties.url;
        if (properties.typeProperties.servicePrincipalId) {
            linkedService.authenticationType = AuthenticationType.ServicePrincipal;
            linkedService.servicePrincipalId = properties.typeProperties.servicePrincipalId;
            linkedService.servicePrincipalKey = secretBaseToPasswordOrAKV(properties.typeProperties.servicePrincipalKey, true, this.context);
            linkedService.tenant = properties.typeProperties.tenant;
        } else if (properties.typeProperties.encryptedCredential || properties.typeProperties.accountKey) {
            linkedService.authenticationType = AuthenticationType.AccountKey;
            linkedService.accountKey = secretBaseToPasswordOrAKV(properties.typeProperties.accountKey, true, this.context);
        } else if (properties.typeProperties.credential) {
            linkedService.authenticationType = AuthenticationType.Credential;
            linkedService.credential = ReferenceAdapter.toProxyModel(Metamodel.modelFor(Credential), properties.typeProperties.credential, this.context);
        } else {
            linkedService.authenticationType = AuthenticationType.ManagedServiceIdentity;
        }
        return linkedService;
    }
}
